import { connect } from 'react-redux'
import ManageIpAddress from './ManageIpAddress'
import * as actions from './actions'

const mapStateToProps = (state, ownProps) => ({
  domainId: state.loginLayout.user.fvdomain_id,
  view: state.loginLayout.view,
  ...ownProps
})

const mapDispatchToProps = dispatch => ({
  updateIpAddresses: (token, domainId, ipAddresses) => dispatch(actions.updateIpAddresses(token, domainId, ipAddresses))
})

const ManageIpAddressContainer = connect(mapStateToProps, mapDispatchToProps)(
  ManageIpAddress
)

export default ManageIpAddressContainer



// WEBPACK FOOTER //
// src/routes/ManageIpAddress/ManageIpAddressContainer.js